import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import useGetData from "../Custom-Hooks/useGetData";
import { getCurrentFormattedMonthYear } from "../../utils/dateUtils";
import GlobalLoader from "../shared/GlobalLoader";

const PipeAnalysis = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const currentdate = getCurrentFormattedMonthYear();
  const selectedCustomerId = localStorage.getItem("customerId") || 0;
  const selectedLocationId = localStorage.getItem("selectedLocationId") || 0;

  const { data: pipeData, isLoading: isLoading } = useGetData(
    `${baseUrl}/customer/pipe_analysis/${selectedCustomerId}/${selectedLocationId}`
  );

  const hookData = pipeData?.overlay?.hookData;
  const allIssuesCount = pipeData?.overlay?.hookData?.issues || 0;

  const temperatureData = [
    {
      label: "Pipe Capacities",
      type: "",
      hasIssues: allIssuesCount > 0, // Determine if there are any issues
    },
  ];

  const isHookDataEmpty = !hookData || Object.keys(hookData).length === 0;

  return (
    <div>
      {isLoading && <GlobalLoader />}
      <div className="col-12 px-3 py-4 d-flex align-items-center justify-content-between">
        <div>
          <div className="fnt14 fw-600">Pipe Analysis</div>
          {pipeData?.updated_at &&
            <div className="fnt12 fw-500 text-secondary">
              MEB&nbsp;–&nbsp;
              {new Date(pipeData.updated_at).toLocaleDateString('en-US', {
                month: 'short',
                year: 'numeric'
              })}
            </div>
          }
        </div>
        <div>
          <div className="default-button">{allIssuesCount} Issues</div>
        </div>
      </div>
      <div className="col-12 px-3">
        <div className="temperature-container">
          {!isHookDataEmpty ? (
            temperatureData?.map((item, index) => (
              <div
                key={index}
                className={`temperature-item ${!item.hasIssues ? "disabled" : ""
                  }`}
              >
                <span>{item.label}</span>
                <Link
                  to={item.hasIssues ? "/dashboard/pipe-analysis" : "#"}
                  state={{ type: item.type, pipeData: pipeData }}
                  className={`icon-container ${item.hasIssues ? "orange" : "gray"
                    }`}
                >
                  <FaExternalLinkAlt />
                </Link>
              </div>
            ))
          ) : (
            <div className="fnt12 d-flex align-items-center justify-content-center height-150">No data to display</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PipeAnalysis;